import Icon from '@ant-design/icons';
import * as React from 'react';

const HamburgerSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20px"
    height="20px"
    fill="currentColor"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </svg>
);

const MenuIcon = (props: any) => (
  <Icon component={HamburgerSvg} {...props} color="white" />
);

export default MenuIcon;
